export default __webpack_public_path__ + "static/media/screen_livechat_17.2b09e0b4.png";